import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const NavigationPin_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2.75C5.95441 2.75 4.25 4.47761 4.25 6.66667C4.25 7.73835 4.661 8.70431 5.32269 9.40889L5.35764 9.44611L8 13.1624L10.6423 9.44614L10.6773 9.40892C11.339 8.70434 11.75 7.73836 11.75 6.66667C11.75 4.47761 10.0456 2.75 8 2.75ZM7.90616 13.2944C7.90613 13.2944 7.9062 13.2943 7.90616 13.2944V13.2944ZM2.75 6.66667C2.75 3.70107 5.07503 1.25 8 1.25C10.925 1.25 13.25 3.70107 13.25 6.66667C13.25 8.10844 12.7029 9.42372 11.8068 10.397L9.12865 14.1636C8.87082 14.5262 8.45385 14.75 8 14.75C7.54614 14.75 7.12917 14.5262 6.87134 14.1636L4.1932 10.397C3.29706 9.42369 2.75 8.10842 2.75 6.66667ZM8 5.25C7.30964 5.25 6.75 5.80964 6.75 6.5C6.75 7.19036 7.30964 7.75 8 7.75C8.69036 7.75 9.25 7.19036 9.25 6.5C9.25 5.80964 8.69036 5.25 8 5.25ZM5.25 6.5C5.25 4.98122 6.48122 3.75 8 3.75C9.51878 3.75 10.75 4.98122 10.75 6.5C10.75 8.01878 9.51878 9.25 8 9.25C6.48122 9.25 5.25 8.01878 5.25 6.5Z"
            />
        </SvgStyled>
    );
};

export default NavigationPin_xs;
